import { render, staticRenderFns } from "./TrainingBaseBlockHome.vue?vue&type=template&id=3ffa3ffc&scoped=true&"
import script from "./TrainingBaseBlockHome.vue?vue&type=script&lang=js&"
export * from "./TrainingBaseBlockHome.vue?vue&type=script&lang=js&"
import style0 from "./TrainingBaseBlockHome.vue?vue&type=style&index=0&id=3ffa3ffc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffa3ffc",
  null
  
)

export default component.exports